module.exports = __webpack_public_path__ + "media/components/home/masthead/img/lavakidneys_530x400@2x-3482778ae21d562dc47e8eced614b6b1.jpg";